import dayjs from "dayjs"
import { getDocumentById } from "api"
import fileDownload from "js-file-download"
import { v4 as uuidv4 } from "uuid"

export const orderByDflt = data => {
  if (data) {
    return data.sort(
      (a, b) => a.cuentaContable.ordenDflt - b.cuentaContable.ordenDflt,
    )
  }
}

export const orderBy = data => {
  let newData = { ...data }

  if (Object.entries(data).length !== 0) {
    newData = newData.balances.map(item => ({
      ...item,
      detalle: item.detalle.sort(
        (a, b) => a.cuentaContable.ordenDflt - b.cuentaContable.ordenDflt,
      ),
    }))

    const detalles = newData
      .map((item, x) =>
        item.detalle.map(i => {
          if (x > 0) {
            return {
              codCuenta: i.codCuenta,
              importe: i.importe,
              montoAjustado: i.montoAjustado,
              varHorizontal: i.varHorizontal,
              varVertical: i.varVertical,
            }
          }
        }),
      )
      .slice(1)

    newData[0].detalle.filter((item, i) => {
      detalles.forEach((x, iterator) => {
        x.forEach(y => {
          if (y.codCuenta === item.codCuenta) {
            if (iterator === 0) {
              const { importe, montoAjustado, varHorizontal, varVertical } = y
              newData[0].detalle[i].importe_1 = importe
              newData[0].detalle[i].montoAjustado_1 = montoAjustado
              newData[0].detalle[i].varHorizontal_1 = varHorizontal
              newData[0].detalle[i].varVertical_1 = varVertical
            }

            if (iterator === 1) {
              const { importe, montoAjustado, varHorizontal, varVertical } = y
              newData[0].detalle[i].importe_2 = importe
              newData[0].detalle[i].montoAjustado_2 = montoAjustado
              newData[0].detalle[i].varHorizontal_2 = varHorizontal
              newData[0].detalle[i].varVertical_2 = varVertical
            }
          }
        })
      })
    })

    const copyArr = newData[0].detalle

    copyArr.map(item => {
      if (item.cuentaContable.clasificacion === 999) {
        item.importe = null
        item.importe_1 = null
        item.montoAjustado_1 = null
        item.importe_2 = null
        item.montoAjustado_2 = null
        item.varHorizontal = null
        item.varHorizontal_1 = null
        item.varHorizontal_2 = null
        item.varVertical = null
        item.varVertical_1 = null
        item.varVertical_2 = null
      }
    })

    if (newData[0].detalle[0].cuentaContable.dsc !== "Número de Balance: ") {
      copyArr.unshift(
        {
          id: 0,
          cuentaContable: { dsc: "Número de Balance: " },
          importe_2: newData[2]?.id,
          montoAjustado_2: "-",
          varVertical_2: newData[2]?.meses + " meses",
          importe_1: newData[1]?.id,
          montoAjustado_1: "-",
          varVertical_1: newData[1]?.meses + " meses",
          varHorizontal_1: "",
          importe: newData[0].id,
          montoAjustado: "-",
          varVertical: newData[0].meses + " meses",
          varHorizontal: "",
        },
        {
          id: 1,
          cuentaContable: { dsc: "Fecha de Cierre: " },
          importe_2: dayjs(newData[2]?.fcierreBalance).format("DD/MM/YYYY"),
          montoAjustado_2: "Ajustado",
          varVertical_2: "Var. Vert.",
          importe_1: dayjs(newData[1]?.fcierreBalance).format("DD/MM/YYYY"),
          montoAjustado_1: "Ajustado",
          varVertical_1: "Var. Vert.",
          varHorizontal_1: "Var. Horiz.",
          importe: dayjs(newData[0].fcierreBalance).format("DD/MM/YYYY"),
          montoAjustado: "Ajustado",
          varVertical: "Var. Vert.",
          varHorizontal: "Var. Horiz.",
        },
      )
    }
    return copyArr
  }
}

export const parseEoaf = data => {
  if (data) {
    const newData = [...data]
    const { leyenda1, leyenda2 } = newData[0] || ""

    if (data.length > 0) {
      newData.unshift({
        formula: "",
        titulo: 999,
        valor1: leyenda1,
        valor2: leyenda2,
      })
    }

    return newData
  }
}

export const parseTablesIb = (data, str) => {
  if (data) {
    const newData = [...data]
    const { titulo_1, titulo_2, titulo_3 } = newData[0] || ""

    if (data.length > 0) {
      newData.unshift({
        error_1: "",
        error_2: "",
        error_3: "",
        descriptivo: !str ? "Concepto" : "",
        titulo: 999,
        indicador_Balance1: titulo_1,
        indicador_Balance2: titulo_2,
        indicador_Balance3: titulo_3,
      })
    }

    return newData
  }
}

export const orderByProperty = (array, property) => {
  return array.sort((a, b) => {
    return a[property] > b[property] ? 1 : -1
  })
}

export const downloadDocument = data => {
  const { url, name } = data

  getDocumentById(url).then(response => {
    fileDownload(response, name)
  })
}

export const orderByDate = (arr, property) => {
  const newArr = arr.sort(function compare(a, b) {
    var dateA = new Date(a[property])
    var dateB = new Date(b[property])
    return dateB - dateA
  })
  return newArr
}

export const orderByYear = (array, property) => {
  return array.sort((a, b) => {
    return a[property] < b[property] ? 1 : -1
  })
}

export const parseTableColumns = (columns, userCanEdit) => {
  const newColumns = [...columns]
  if (!userCanEdit) {
    newColumns.pop()
  }
  return newColumns
}

export const resolvePermisos = (roles, perfiles) => {
  if (!roles?.length || !perfiles?.length) {
    return { hasAccess: false }
  }

  const rolesDeUsuario = []

  roles.forEach(role => {
    const roleName = role.replace("ROLE_", "").toUpperCase()
    perfiles.forEach(item => {
      if (
        item.descripcion &&
        item.descripcion.toUpperCase().indexOf(roleName) > -1
      ) {
        rolesDeUsuario.push(item)
      }
    })
  })

  if (!rolesDeUsuario.length) {
    return { hasAccess: false }
  }

  const esAdmin = rolesDeUsuario.some(p => p.admin === true)

  if (esAdmin) {
    // BDSJEA-14: se conserva la ruta del objeto. Sin ella, el gating por
    // matriz no tiene con qué identificar la pantalla y falla cerrado para
    // todo el mundo.
    const porObjeto = new Map()
    rolesDeUsuario.forEach(p => {
      p.permisos.forEach(perm => {
        if (!porObjeto.has(perm.nombreObjeto)) {
          porObjeto.set(perm.nombreObjeto, perm.route)
        }
      })
    })
    const filteredPermisos = Array.from(porObjeto.entries()).map(
      ([nombreObjeto, route]) => ({
        nombreObjeto,
        route,
        modificacion: true,
        consulta: true,
        habilitaAcceso: true,
      }),
    )

    const parsedPerfiles = perfiles.map(profile => ({
      ...profile,
      permisos: profile.permisos.map(permiso => ({
        ...permiso,
        id: permiso.id === 0 ? uuidv4() : permiso.id,
      })),
    }))

    return {
      permisos: filteredPermisos,
      perfiles: parsedPerfiles,
      hasAccess: true,
      admin: true,
    }
  }

  const unifiedArray = [].concat(...rolesDeUsuario.map(obj => obj.permisos))

  const groupedObjects = unifiedArray.reduce((result, obj) => {
    const key = obj.nombreObjeto
    result[key] = result[key] || []
    result[key].push(obj)
    return result
  }, {})

  const filteredPermisos = Object.keys(groupedObjects).map(key => {
    const obj = groupedObjects[key]
    const modificacion = obj.some(item => item.modificacion)
    const consulta = obj.some(item => item.consulta)
    const habilitaAcceso = obj.some(item => item.habilitaAcceso)
    const route = obj.find(item => item.route)?.route

    return { nombreObjeto: key, route, modificacion, consulta, habilitaAcceso }
  })

  const parsedPerfiles = perfiles.map(profile => ({
    ...profile,
    permisos: profile.permisos.map(permiso => ({
      ...permiso,
      id: permiso.id === 0 ? uuidv4() : permiso.id,
    })),
  }))

  return {
    permisos: filteredPermisos,
    perfiles: parsedPerfiles,
    hasAccess: true,
    admin: false,
  }
}
